module.exports = __webpack_public_path__ + "img/eventName.cd166207.png";